import React from 'react';

const SkeletonCell: React.FC<{ width?: string }> = ({ width = '90%' }) => (
  <div className="skeleton-cell" style={{ width }}>
    <div className="skeleton" />
  </div>
);

export default SkeletonCell;
